import baseApi, { TAGS } from './baseApi';

/************************************************** API **************************************************/
const tasksApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: (userId) => ({
        url: `tasks`,
        params: { userId },
        method: 'GET'
      }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.TASKS]
    })
  })
});

/************************************************** HOOKS **************************************************/
export const { useGetTasksQuery } = tasksApi;
